import Request from './request'

const SimServer = {
  updateStatus(callback) {
    Request.get('sim-server/update-status').then(callback).catch(this.bad_answer)
  },
  getSimReaders(callback) {
    Request.get('sim-server/sim-readers').then(callback).catch(this.bad_answer)
  },
  getSimServers(callback) {
    Request.get('sim-server/sim-servers').then(callback).catch(this.bad_answer)
  },
  getRemoteSims(params, callback) {
    Request.get('sim-server/simcards', params).then(callback).catch(this.bad_answer)
  },
  getRemoteSimInfo(id, callback) {
    Request.get('sim-server/simcard/' + id).then(callback).catch(this.bad_answer)
  },
  bindSimcard(params, callback) {
    Request.post('sim-server/bind-simcard', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  unbindSimcard(id, callback) {
    Request.get('sim-server/unbind-simcard/' + id).then(callback).catch(this.bad_answer)
  },
  unloadSimcard(id, callback) {
    Request.get('sim-server/unload-simcard/' + id).then(callback).catch(this.bad_answer)
  },
  resetSimcardStatus(id, callback) {
    Request.get('sim-server/reset-simcard-status/' + id).then(callback).catch(this.bad_answer)
  },
  getClientSettings(callback) {
    Request.get('sim-server/clients-settings').then(callback).catch(this.bad_answer)
  },

}
export default SimServer
